import { checkSettingsStore } from '@/services/SettingsStoreUpdateService'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'

/**
 * Returns stored text if condition key enabled.
 *
 * @param {string} conditionKey - The key to check in `store.settings` to determine if the value should be returned.
 * @param {string} valueKey - The key to retrieve from `store.settings.custom` if the condition is met.
 * @param {string | null | undefined} defaultValue - Fallback value if the stored text is unavailable or disabled.
 *
 * @returns {string | null} - The value from `store.settings.custom[valueKey]` if the condition is met; otherwise `null`.
 *
 * @example
 * const platformLabel = usePlatformSettingsString(
 *   'enableFeatureX',
 *   'featureXText',
 *   'default for this'
 * );
 */
export const usePlatformSettingsString = (
  conditionKey: string,
  valueKey: string,
  defaultValue?: string | null,
): string | null => {
  useEffect(() => {
    checkSettingsStore()
  }, [])

  const value = useSelector((store: any) => {
    const condition = store.settings?.[conditionKey] === '1'
    const value = store.settings?.custom?.[valueKey] ?? null
    return condition ? value : null
  })

  return !!value ? value : defaultValue ?? null
}
